<template>
  <div class="employee-issues-user-report">
    <div class="employee-tasks-user-report__row">
      <div class="employee-tasks-user-report__chart-column">
        <e-charts :options="line" ref="line" auto-resize theme="ovilia-green" width="100%" />
      </div>
    </div>
  </div>
</template>

<script>
  import ECharts from 'vue-echarts/components/ECharts'
  import 'echarts/lib/component/tooltip'
  import 'echarts/lib/component/legend'
  import 'echarts/lib/chart/bar'
  import theme from '@/assets/echarts-themes/tasks-report-charts';

  ECharts.registerTheme('ovilia-green', theme);

  export default {
    name: "PerformersAnalytics",
    props: {
      period: {},
      performer: {},
      isPerformersLoaded: {},
    },
    components: {
      ECharts
    },
    data(){
      return {
        info: {}
      };
    },
    computed: {
      CHART_LEGENDS(){
        return this.$store.getters['common/tasks/statuses'];
      },
      dateList(){
        let dateStart = this.$moment(this.period.from);
        let dateEnd = this.$moment(this.period.to);
        let list = [];
        while (dateEnd >= dateStart) {
          list.push(dateStart.format('DD.MM.YYYY'));
          dateStart.add(1, 'day');
        }
        return list;
      },
      valueDoneList(){
        return this.getValuesByStatus(this.CHART_LEGENDS.done.id);
      },
      line() {
        let interval = 0;

        if(this.dateList.length > 100){
          interval = 20;
        }
        else if(this.dateList.length > 32){
          interval = 4;
        }
        else if(this.dateList.length > 20){
          if( this.windowWidth <= 1366){
            interval = 1;
          }
        }
        else{
          if(this.windowWidth <= 1200){
            interval = 3;
          }
        }

        return {
          color: ['#7bd9a5'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: Object.values(this.CHART_LEGENDS).map(l => l.name)
          },
          xAxis: {
            data: this.dateList,
            axisLabel: {
              interval: interval,
              rotate: 20
            }
          },
          yAxis: {
            splitLine: {show: false},
          },
          series: [
            {
              type: 'bar',
              data: this.valueDoneList
            }
          ]
        }
      },
    },
    methods: {
      getValuesByStatus(status){
        let values = [];

        this.dateList.forEach(date => {
          let object = this.info[date] || 0;
          values.push(object);
        });

        return values;
      },
      async updateData(){
        let params = {
          performer_id: typeof this.performer === typeof 0 ? this.performer : (this.performer.id || 0),
          startDate: this.$options.filters.moment(this.period.from, 'YYYY-MM-DD'),
          endDate: this.$options.filters.moment(this.period.to, 'YYYY-MM-DD')
        };

        let {data} = await this.$http.get('tasks/report', {
          params: params
        });
        let foramattedData = {};
        for (let index in data){
          if(data.hasOwnProperty(index)){
            let date = this.$options.filters.moment(this.$parseDateFromString(index), 'DD.MM.YYYY');
            foramattedData[date] = data[index];
          }
        }
        this.info = foramattedData;
      }
    },
    mounted() {
    },
    watch: {
      isPerformersLoaded(){
        this.updateData();
      }
    }
  }
</script>

<style lang="scss">
  .employee-issues-user-report{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__row{
      display: flex;
      align-items: center;
      flex: 1;
    }

    &__chart-column{
      flex: 1;
      margin-bottom: 30px;
      max-width: 100%;

      &_pie{
        flex: 0 0 480px;
      }

      &_line{
        flex: 1;
        max-width: calc(100% - 480px);
      }
    }
  }
</style>